import { CountryNamedLocation, IpNamedLocation } from '@microsoft/microsoft-graph-types-beta';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'namedLocations';

export type CustomNamedLocation = CountryNamedLocation & IpNamedLocation;

export interface State extends EntityState<CustomNamedLocation>, Status {}

export const adapter: EntityAdapter<CustomNamedLocation> = createEntityAdapter<CustomNamedLocation>();

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    // load

    on(actions.loadNamedLocationsSuccess, (state, action) =>
        adapter.upsertMany(action.polices, { ...state, loaded: true, error: null }),
    ),
    on(actions.loadNamedLocationsFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    on(actions.createNamedLocationSuccess, (state, { location }) =>
        adapter.addOne(location, { ...state, error: null }),
    ),
    on(actions.updateNamedLocationSuccess, (state, { location }) =>
        adapter.updateOne({ id: location.id, changes: location }, { ...state, error: null }),
    ),

    on(actions.deleteNamedLocationSuccess, (state, { id }) => adapter.removeOne(id, { ...state, error: null })),
    on(actions.createNamedLocationFailure, (state, { error }) => ({
        ...state,
        error,
    })),
    on(actions.updateNamedLocationFailure, (state, { error }) => ({
        ...state,
        error,
    })),
    on(actions.deleteNamedLocationFailure, (state, { error }) => ({
        ...state,
        error,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
